module.exports = __webpack_public_path__ + "img/partner3.dc7e43ba.png";